import { BreadcrumbRoute } from '~hooks/use-bread-crumbs';

import { ROUTES } from '~app/router/routes';

export const breadcrumbsRoutes: BreadcrumbRoute[] = [
  {
    path: ROUTES.DASHBOARD,
    breadcrumb: 'Головна',
  },
  {
    path: ROUTES.PROPERTIES,
    breadcrumb: 'Нерухомість',
  },
  {
    path: ROUTES.NEW_PROPERTY,
    breadcrumb: 'Новий обʼєкт нерухомості',
  },
  {
    path: ROUTES.EDIT_PROPERTY,
    breadcrumb: 'Редагування обʼєкту',
  },
  {
    path: ROUTES.PROPERTY,
    breadcrumb: 'Сторінка обʼєкту',
  },

  {
    path: ROUTES.TENANTS,
    breadcrumb: 'Орендарі',
  },
  {
    path: ROUTES.NEW_TENANT,
    breadcrumb: 'Новий орендар',
  },
  {
    path: ROUTES.TENANT,
    breadcrumb: 'Сторінка орендаря',
  },
  {
    path: ROUTES.EDIT_TENANT,
    breadcrumb: 'Редагування орендаря',
  },

  {
    path: ROUTES.REMINDERS,
    breadcrumb: 'Нагадування',
  },
  {
    path: ROUTES.NEW_REMINDER,
    breadcrumb: 'Нове нагадування',
  },
  // {
  //   path: ROUTES.REMINDER,
  //   breadcrumb: 'Сторінка нагадування',
  // },
  {
    path: ROUTES.EDIT_REMINDER,
    breadcrumb: 'Редагування нагадування',
  },

  {
    path: ROUTES.LEASES,
    breadcrumb: 'Договори оренди',
  },
  {
    path: ROUTES.NEW_LEASE,
    breadcrumb: 'Новий договір',
  },
  {
    path: ROUTES.LEASE,
    breadcrumb: 'Сторінка договору',
  },
  {
    path: ROUTES.EDIT_LEASE,
    breadcrumb: 'Редагування договору',
  },
  {
    path: ROUTES.LEASE_CREATED,
    breadcrumb: 'Успішно створено',
  },

  {
    path: ROUTES.INVOICES,
    breadcrumb: 'Рахунки',
  },
  {
    path: ROUTES.NEW_INVOICE,
    breadcrumb: 'Новий рахунок',
  },
  {
    path: ROUTES.INVOICE,
    breadcrumb: 'Сторінка рахунку',
  },
  {
    path: ROUTES.EDIT_INVOICE,
    breadcrumb: 'Редагування рахунку',
  },

  {
    path: ROUTES.PAYMENTS_RECORDS,
    breadcrumb: 'Платежі',
  },
  {
    path: ROUTES.NEW_PAYMENT_RECORD,
    breadcrumb: 'Новий платіж',
  },
  {
    path: ROUTES.PAYMENT_RECORD,
    breadcrumb: 'Сторінка платежу',
  },
  {
    path: ROUTES.EDIT_PAYMENT_RECORD,
    breadcrumb: 'Редагування платежу',
  },
  {
    path: ROUTES.SUPPORT,
    breadcrumb: 'Служба турботи',
  },
  {
    path: ROUTES.TENANT_SUPPORT,
    breadcrumb: 'Служба турботи',
  },
];
